// System Wallet (Master DB) Action Types

// Wallet list (admin overview)
export const GET_SYSTEM_WALLET_LIST = "GET_SYSTEM_WALLET_LIST";
export const GET_SYSTEM_WALLET_LIST_SUCCESS = "GET_SYSTEM_WALLET_LIST_SUCCESS";
export const GET_SYSTEM_WALLET_LIST_FAILURE = "GET_SYSTEM_WALLET_LIST_FAILURE";

// Single wallet (by Company_Id)
export const GET_SYSTEM_WALLET_DATA = "GET_SYSTEM_WALLET_DATA";
export const GET_SYSTEM_WALLET_DATA_SUCCESS = "GET_SYSTEM_WALLET_DATA_SUCCESS";
export const GET_SYSTEM_WALLET_DATA_FAILURE = "GET_SYSTEM_WALLET_DATA_FAILURE";

// Update wallet settings
export const UPDATE_SYSTEM_WALLET = "UPDATE_SYSTEM_WALLET";
export const UPDATE_SYSTEM_WALLET_SUCCESS = "UPDATE_SYSTEM_WALLET_SUCCESS";
export const UPDATE_SYSTEM_WALLET_FAILURE = "UPDATE_SYSTEM_WALLET_FAILURE";

// Manual top-up
export const TOPUP_SYSTEM_WALLET = "TOPUP_SYSTEM_WALLET";
export const TOPUP_SYSTEM_WALLET_SUCCESS = "TOPUP_SYSTEM_WALLET_SUCCESS";
export const TOPUP_SYSTEM_WALLET_FAILURE = "TOPUP_SYSTEM_WALLET_FAILURE";

// Ledger / transactions
export const GET_SYSTEM_WALLET_TRANSACTIONS = "GET_SYSTEM_WALLET_TRANSACTIONS";
export const GET_SYSTEM_WALLET_TRANSACTIONS_SUCCESS =
  "GET_SYSTEM_WALLET_TRANSACTIONS_SUCCESS";
export const GET_SYSTEM_WALLET_TRANSACTIONS_FAILURE =
  "GET_SYSTEM_WALLET_TRANSACTIONS_FAILURE";

// Manual adjust (credit)
export const ADJUST_SYSTEM_WALLET = "ADJUST_SYSTEM_WALLET";
export const ADJUST_SYSTEM_WALLET_SUCCESS = "ADJUST_SYSTEM_WALLET_SUCCESS";
export const ADJUST_SYSTEM_WALLET_FAILURE = "ADJUST_SYSTEM_WALLET_FAILURE";

// ***** Customer-facing own wallet (Company_Id resolved from the token) *****
// Own wallet (balance + settings)
export const GET_MY_WALLET = "GET_MY_WALLET";
export const GET_MY_WALLET_SUCCESS = "GET_MY_WALLET_SUCCESS";
export const GET_MY_WALLET_FAILURE = "GET_MY_WALLET_FAILURE";

// Own wallet ledger
export const GET_MY_WALLET_TRANSACTIONS = "GET_MY_WALLET_TRANSACTIONS";
export const GET_MY_WALLET_TRANSACTIONS_SUCCESS =
  "GET_MY_WALLET_TRANSACTIONS_SUCCESS";
export const GET_MY_WALLET_TRANSACTIONS_FAILURE =
  "GET_MY_WALLET_TRANSACTIONS_FAILURE";

// Own wallet top-up
export const TOPUP_MY_WALLET = "TOPUP_MY_WALLET";
export const TOPUP_MY_WALLET_SUCCESS = "TOPUP_MY_WALLET_SUCCESS";
export const TOPUP_MY_WALLET_FAILURE = "TOPUP_MY_WALLET_FAILURE";

// Own wallet settings update
export const UPDATE_MY_WALLET = "UPDATE_MY_WALLET";
export const UPDATE_MY_WALLET_SUCCESS = "UPDATE_MY_WALLET_SUCCESS";
export const UPDATE_MY_WALLET_FAILURE = "UPDATE_MY_WALLET_FAILURE";

// Service types (CRUD)
export const GET_SYSTEM_WALLET_SERVICE_TYPE_LIST =
  "GET_SYSTEM_WALLET_SERVICE_TYPE_LIST";
export const GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_SUCCESS =
  "GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_SUCCESS";
export const GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_FAILURE =
  "GET_SYSTEM_WALLET_SERVICE_TYPE_LIST_FAILURE";

export const CREATE_SYSTEM_WALLET_SERVICE_TYPE =
  "CREATE_SYSTEM_WALLET_SERVICE_TYPE";
export const CREATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS =
  "CREATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS";
export const CREATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE =
  "CREATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE";

export const UPDATE_SYSTEM_WALLET_SERVICE_TYPE =
  "UPDATE_SYSTEM_WALLET_SERVICE_TYPE";
export const UPDATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS =
  "UPDATE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS";
export const UPDATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE =
  "UPDATE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE";

export const DELETE_SYSTEM_WALLET_SERVICE_TYPE =
  "DELETE_SYSTEM_WALLET_SERVICE_TYPE";
export const DELETE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS =
  "DELETE_SYSTEM_WALLET_SERVICE_TYPE_SUCCESS";
export const DELETE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE =
  "DELETE_SYSTEM_WALLET_SERVICE_TYPE_FAILURE";

// Service rates (CRUD)
export const GET_SYSTEM_WALLET_SERVICE_RATE_LIST =
  "GET_SYSTEM_WALLET_SERVICE_RATE_LIST";
export const GET_SYSTEM_WALLET_SERVICE_RATE_LIST_SUCCESS =
  "GET_SYSTEM_WALLET_SERVICE_RATE_LIST_SUCCESS";
export const GET_SYSTEM_WALLET_SERVICE_RATE_LIST_FAILURE =
  "GET_SYSTEM_WALLET_SERVICE_RATE_LIST_FAILURE";

export const CREATE_SYSTEM_WALLET_SERVICE_RATE =
  "CREATE_SYSTEM_WALLET_SERVICE_RATE";
export const CREATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS =
  "CREATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS";
export const CREATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE =
  "CREATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE";

export const UPDATE_SYSTEM_WALLET_SERVICE_RATE =
  "UPDATE_SYSTEM_WALLET_SERVICE_RATE";
export const UPDATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS =
  "UPDATE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS";
export const UPDATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE =
  "UPDATE_SYSTEM_WALLET_SERVICE_RATE_FAILURE";

export const DELETE_SYSTEM_WALLET_SERVICE_RATE =
  "DELETE_SYSTEM_WALLET_SERVICE_RATE";
export const DELETE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS =
  "DELETE_SYSTEM_WALLET_SERVICE_RATE_SUCCESS";
export const DELETE_SYSTEM_WALLET_SERVICE_RATE_FAILURE =
  "DELETE_SYSTEM_WALLET_SERVICE_RATE_FAILURE";

// Reset transient responses (topup / adjust / update / create / delete)
export const SYSTEM_WALLET_RESET_RESPONSE = "SYSTEM_WALLET_RESET_RESPONSE";
